module.exports = __webpack_public_path__ + "img/组 10.3af95dca.png";